import { ColumnsType } from "antd/lib/table";
import { useMemo } from "react";

export const useColumns = <T>(
  cols: Record<string, unknown>[],
): ColumnsType<T> => {
  const columns: ColumnsType<T> = useMemo(() => [...cols], [cols]);
  return columns;
};
